import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { NavItem, Nav } from 'reactstrap';
import { getPermission, READ_ONLY } from 'permissions';
import { Installer, Radius, RadiusAdmin } from 'config/roles';

const Aux = props => props.children;

export const NavLinks = ({ role, location }) => {
  const NavLink = ({ to, ...props }) =>
    getPermission(to, role) >= READ_ONLY && (
      <NavItem>
        <Link
          to={`/${to}`}
          {...props}
          className={classNames(
            'nav-link',
            location.pathname.indexOf(`/${to}`) === 0 && 'current'
          )}
        />
      </NavItem>
    );

  return (
    <Nav navbar key="leftNav" className="mr-auto">
      {role === Installer && (
        <Aux>
          {
          /*<NavLink to="new-orders" role={role}>
            New Orders
          </NavLink>
          */
          }
          {/*<NavLink to="unassigned-orders" role={role}>*/}
          {/*  Unassigned Orders*/}
          {/*</NavLink>*/}
          <NavLink to="all-orders" role={role}>
            All Orders
          </NavLink>
          <NavLink to="assigned-orders" role={role}>
            Assigned Orders
          </NavLink>
          <NavLink to="completed-jobs" role={role}>
            Completed Jobs
          </NavLink>
          <NavLink to="installer-users">Users</NavLink>
        </Aux>
      )}
      {role >= Radius && (
        <Aux>
          <NavLink to="all-orders" role={role}>
            All Orders
          </NavLink>
          <NavLink to="unassigned-orders" role={role}>
            Unassigned Orders
          </NavLink>
          <NavLink to="assigned-orders" role={role}>
            Assigned Orders
          </NavLink>
          {
            /*
              <NavLink to="rejected-orders" role={role}>
                Rejected Orders
              </NavLink>
            */
          }
          <NavLink to="completed-jobs" role={role}>
            Completed Jobs
          </NavLink>
          <NavLink to="installers">Installers</NavLink>
          <NavLink to="installer-rules">Installer Rules</NavLink>
        </Aux>
      )}
      {role === RadiusAdmin && <NavLink to="admin">Admin</NavLink>}
      {role === RadiusAdmin && <NavLink to="users">Users</NavLink>}
    </Nav>
  );
};

export default NavLinks;



// WEBPACK FOOTER //
// ./src/nav.jsx